import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  TreatmentPlanMaster_Create,
  TreatmentPlanMaster_Delete,
  TreatmentPlanMaster_GetDashboardPatientCountsKPI,
  TreatmentPlanMaster_ReadAll,
  TreatmentPlanMaster_ReadAllPaginated,
  TreatmentPlanMaster_ReadByDoctorId,
  TreatmentPlanMaster_ReadByDoctorIdAndDate,
  TreatmentPlanMaster_ReadByHospitalId,
  TreatmentPlanMaster_ReadById,
  TreatmentPlanMaster_ReadByPatientId,
  TreatmentPlanMaster_Update,
} from "src/app/GlobalVariable/Hospital.GlobalVariable";
import {
  DashboardPatientCountsKPIReeuestDTO,
  TreatmentPlanMasterCreateRequestDTO,
  TreatmentPlanMasterDeleteRequestDTO,
  TreatmentPlanMasterDTO,
  TreatmentPlanMasterList,
  TreatmentPlanMasterReadAllPaginatedRequestDTO,
  TreatmentPlanMasterReadByBedIdRequestDTO,
  TreatmentPlanMasterReadByDoctorIdAndDateRequestDTO,
  TreatmentPlanMasterReadByDoctorIdRequestDTO,
  TreatmentPlanMasterReadByHospitalIdRequestDTO,
  TreatmentPlanMasterReadByIdRequestDTO,
  TreatmentPlanMasterReadByPatientIdRequestDTO,
  TreatmentPlanMasterUpdateRequestDTO,
} from "./hospital-treatment-plan.interface";

@Injectable({
  providedIn: "root",
})
export class TreatmentPlanMasterService {
  http = inject(HttpClient);

  TreatmentPlanMaster_Create(
    data: TreatmentPlanMasterCreateRequestDTO,
  ): Observable<TreatmentPlanMasterDTO> {
    return this.http.post<TreatmentPlanMasterDTO>(
      TreatmentPlanMaster_Create,
      data,
    );
  }

  TreatmentPlanMaster_ReadAll(): Observable<TreatmentPlanMasterList> {
    return this.http.get<TreatmentPlanMasterList>(TreatmentPlanMaster_ReadAll);
  }

  TreatmentPlanMaster_ReadById(
    data: TreatmentPlanMasterReadByIdRequestDTO,
  ): Observable<TreatmentPlanMasterDTO> {
    return this.http.post<TreatmentPlanMasterDTO>(
      TreatmentPlanMaster_ReadById,
      data,
    );
  }

  TreatmentPlanMaster_ReadByDoctorId(
    data: TreatmentPlanMasterReadByDoctorIdRequestDTO,
  ): Observable<TreatmentPlanMasterList> {
    return this.http.post<TreatmentPlanMasterList>(
      TreatmentPlanMaster_ReadByDoctorId,
      data,
    );
  }

  TreatmentPlanMaster_ReadByPatientId(
    data: TreatmentPlanMasterReadByPatientIdRequestDTO,
  ): Observable<TreatmentPlanMasterList> {
    return this.http.post<TreatmentPlanMasterList>(
      TreatmentPlanMaster_ReadByPatientId,
      data,
    );
  }

  TreatmentPlanMaster_ReadByHospitalId(
    data: TreatmentPlanMasterReadByHospitalIdRequestDTO,
  ): Observable<TreatmentPlanMasterList> {
    return this.http.post<TreatmentPlanMasterList>(
      TreatmentPlanMaster_ReadByHospitalId,
      data,
    );
  }

  TreatmentPlanMaster_Update(
    data: TreatmentPlanMasterUpdateRequestDTO,
  ): Observable<TreatmentPlanMasterDTO> {
    return this.http.post<TreatmentPlanMasterDTO>(
      TreatmentPlanMaster_Update,
      data,
    );
  }

  TreatmentPlanMaster_Delete(
    data: TreatmentPlanMasterDeleteRequestDTO,
  ): Observable<void> {
    return this.http.post<void>(TreatmentPlanMaster_Delete, data);
  }

  TreatmentPlanMaster_ReadAllPaginated(
    data: TreatmentPlanMasterReadAllPaginatedRequestDTO,
  ): Observable<TreatmentPlanMasterList> {
    return this.http.post<TreatmentPlanMasterList>(
      TreatmentPlanMaster_ReadAllPaginated,
      data,
    );
  }

  TreatmentPlanMaster_ReadByDoctorIdAndDate(
    data: TreatmentPlanMasterReadByDoctorIdAndDateRequestDTO,
  ): Observable<TreatmentPlanMasterList> {
    return this.http.post<TreatmentPlanMasterList>(
      TreatmentPlanMaster_ReadByDoctorIdAndDate,
      data,
    );
  }

    TreatmentPlanMaster_GetDashboardPatientCountsKPI(
    data: DashboardPatientCountsKPIReeuestDTO,
  ): Observable<TreatmentPlanMasterDTO> {
    return this.http.post<TreatmentPlanMasterDTO>(
      TreatmentPlanMaster_GetDashboardPatientCountsKPI,
      data,
    );
  }
}
